/**
 * @generated by @puffin-tooling/esm-build — DO NOT EDIT BY HAND.
 *
 * Source of truth: this package's CJS entry (`lib/index.js`).
 * Regenerate with `pnpm esm:build`; CI fails if this file is stale
 * (see the esmBuildFreshness cross-app contract).
 *
 * This RE-EXPORTS the CJS surface rather than duplicating it. Hand-editing
 * it reintroduces PLN-CALENDAR-RULE-001 D4: two copies of one module,
 * drifting silently.
 */

import cjs from '../subscriptionStatus.js';

export default cjs;

export const {
  BILLING_ATTENTION_SUBSCRIPTION_STATUSES,
  SUBSCRIPTION_BILLING_MODE,
  SUBSCRIPTION_BILLING_MODE_VALUES,
  SUBSCRIPTION_STATUS,
  SUBSCRIPTION_STATUS_BADGE_TONES,
  SUBSCRIPTION_STATUS_VALUES,
  TRIAL_PERIOD_DAYS,
} = cjs;
